import * as React from "react";

type MarkerProps = {
	position: google.maps.LatLngLiteral;
	draggable: boolean;
	onDragEnd: () => void;
};

type MarkerState = {

};

class Marker extends React.Component<MarkerProps, MarkerState> {
	render(): React.ReactNode {
		throw "this component should never be rendered directly. it is converted to an actual marker used by the underlying system";
	}
}

export default Marker;